const storage = window.localStorage

export const getSessionTokens = () =>
  JSON.parse(storage.getItem('auth') || null)
export const getStorageItem = item => JSON.parse(storage.getItem(item))
export const setStorageItem = (item, value) => storage.setItem(item, value)
export const removeStorageItem = item => storage.removeItem(item)
